import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, MessageCircle, Plus } from "lucide-react";
import { EASE, Reveal } from "./Reveal";
import { FAQS, WA_NUMBER } from "../data";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section faq" id="faq">
      <div className="container faq-grid">
        <Reveal>
          <span className="eyebrow">Punya Pertanyaan?</span>
          <h2 className="h2">
            Yang sering
            <br />
            <em>ditanyakan.</em>
          </h2>
          <p className="faq-side">Belum menemukan jawaban? Chat kami langsung, tim kami dengan senang hati membantu.</p>
          <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noreferrer" className="btn-text" data-testid="faq-whatsapp-link">
            Tanya via WhatsApp <ArrowRight size={15} />
          </a>
        </Reveal>
        <Reveal delay={0.15} className="faq-list">
          <div>
            {FAQS.map((f, i) => (
              <div className={`faq-item ${open === i ? "open" : ""}`} key={f.q}>
                <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-question-${i}`}>
                  <span>{f.q}</span>
                  <span className="faq-ico">
                    <Plus size={15} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                      style={{ overflow: "hidden" }}
                    >
                      <p className="faq-a" data-testid={`faq-answer-${i}`}>
                        {f.a}
                      </p>
                      {f.cta && (
                        <div className="faq-cta">
                          <a
                            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(f.cta.message)}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-faq-wa"
                            data-testid={f.cta.testid}
                          >
                            <MessageCircle size={15} /> {f.cta.label} <ArrowRight size={14} />
                          </a>
                        </div>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
